import { ShoppingCart, Package, Megaphone, Boxes, MessageCircle, Receipt, User, ChevronRight, WalletMinimal, LockKeyhole, BookOpenText } from "lucide-react";
import "./storeNavigation.css";
import { useDispatch } from "react-redux";
import { setPage } from "../../../slice/storeSlice";
import { useState } from "react";
import { useSelector } from "react-redux";
import { uiAlert } from "../../alerts/customAlert/uiAlert";

const menuItems = [
  {
    id: "transaction",
    label: "Sell Items",
    icon: ShoppingCart,
    description: "Add new products to sell",
    iconClass: "icon-sell-items",
  },
  {
    id: "receivedOrder",
    label: "Received Orders",
    icon: Package,
    description: "View and manage orders",
    iconClass: "icon-received-orders",
  },
  {
    id: "advertisement",
    label: "Advertisement",
    icon: Megaphone,
    description: "Promote your products",
    iconClass: "icon-advertisement",
  },
  {
    id: "stockManagement",
    label: "Stock Management",
    icon: Boxes,
    description: "Track inventory levels",
    iconClass: "icon-stock-management",
  },
  {
    id: "messages",
    label: "Messages",
    icon: MessageCircle,
    description: "Customer communications",
    iconClass: "icon-messages",
  },
  {
    id: "expenses",
    label: "Expense",
    icon: Receipt,
    description: "Track business expenses",
    iconClass: "icon-expense",
  },
  {
    id: "storeProfile",
    label: "Store Profile",
    icon: User,
    description: "Manage store settings",
    iconClass: "icon-store-profile",
  },
];

const settingsMenuItems = [
  {
    id: "profile",
    label: "Profile",
    icon: User,
    description: "View and edit your profile",
    iconClass: "icon-profile",
  },
  {
    id: "manage-subscription",
    label: "Manage Subscription",
    icon: Receipt,
    description: "View and manage your subscription",
    iconClass: "icon-manage-subscription",
  },
  {
    id: "wallet",
    label: "Wallet",
    icon: WalletMinimal,
    description: "View your wallet and cards",
    iconClass: "icon-wallet",
  },
  {
    id: "change-password",
    label: "Change Password",
    icon: LockKeyhole,
    description: "Update your password",
    iconClass: "icon-change-password",
  },
  {
    id: "help-support",
    label: "Help & Support",
    icon: MessageCircle,
    description: "Get help and support",
    iconClass: "icon-help-support",
  },
  {
    id: "privacy-policy",
    label: "Privacy Policy",
    icon: BookOpenText,
    description: "Read our privacy policy",
    iconClass: "icon-privacy-policy",
  },
];

const StoreNavigation = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState("");
  const dispatch = useDispatch();
  const { page } = useSelector((state) => state.store);
  const { store } = useSelector((state) => state.store);
  const { employee } = useSelector((state) => state.employee);
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div className='store-dropdown-backdrop' onClick={onClose} />

      {/* Dropdown Content */}
      <div className='store-dropdown-container'>
        <div className='store-dropdown-content'>
          {menuItems.map((item, index) => {
            const Icon = item.icon;

            if (item.id === "receivedOrder" || item.id === "advertisement" || item.id === "messages" || item.id === "storeProfile") {
              if (employee && employee.employeeAccessLevel !== "admin") {
                return null;
              }
            }
            return (
              <button
                key={item.id}
                onClick={() => {
                  if (item.id === "storeProfile" && employee && !employee.permissions.storeProfile) {
                    return uiAlert("You don't have permission to access this page", "error");
                  }
                  console.log("Clicked on:", item.id);
                  dispatch(setPage(item.id));
                  setActiveTab(item.id);
                  onClose();
                }}
                className={"store-dropdown-item" + (page === item.id ? " activeNavTab7364" : "")}
                style={{
                  animationDelay: `${index * 50}ms`,
                  display: ` ${item.id === "transaction" && store.isOnlineStoreOnly ? "none" : "flex"}`,
                }}
              >
                {/* Icon */}
                <div className='store-dropdown-icon-container'>
                  <Icon className={`${item.iconClass}`} size={24} />
                </div>

                {/* Content */}
                <div className='store-dropdown-item-content'>
                  <h3 className='store-dropdown-item-title'>{item.label}</h3>
                  <p className='store-dropdown-item-description'>{item.description}</p>
                </div>

                {/* Arrow */}
                <ChevronRight className='store-dropdown-arrow' size={20} />
              </button>
            );
          })}
        </div>

        {/* Footer */}
        <div className='store-dropdown-footer'>
          <p className='store-dropdown-footer-text'>Manage your store efficiently</p>
        </div>
      </div>
    </>
  );
};

export default StoreNavigation;
